import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/apiService';

export const usePropertyDetail = (id) => {
  return useQuery({
    queryKey: ['property', id],
    queryFn: async () => {
      const response = await apiClient.get(`/api/properties/${id}`);
      return {
        property: response?.property || {},
        bookedDates: response?.booked_dates || [],
      };
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!id,
  });
};
